<div class="panel panel-default margin-bottom-xs">
	<div class="panel-body">
		<ul class="nav nav-tabs">
			<li [ngClass]="{active: activePage == 'listing'}">
				<a class="glyphicon glyphicon-list" (click)="setTab('','listing')"><span style="font-family:sans-serif;">&nbsp;List</span></a>
			</li>
			<li [ngClass]="{active: activePage == 'settings'}" *ngIf="userService.hasAccessFunction('access_device_settings') || userService.hasAccessFunction('act_admin_device_management') || userService.getCurrentUser()?.isACTuser">
				<a class="glyphicon glyphicon-cog" (click)="setTab('','settings')"><span style="font-family:sans-serif;">&nbsp;Settings</span></a>
			</li>
			<li [ngClass]="{active: activePage == 'quick-view'}">
				<a class="glyphicon glyphicon-eye-open" (click)="setTab('','quick-view')"><span style="font-family:sans-serif;">&nbsp;QuickView</span></a>
			</li>
				<li [ngClass]="{active: activePage == 'analytics'}">
				<a class="glyphicon glyphicon-alert" (click)="setTab('faults','analytics')"><span style="font-family:sans-serif;">&nbsp;PolarLink Faults</span></a>
			</li>
			<li [ngClass]="{active: activePage == 'plink-events'}" *ngIf="userService.hasAccessFunction('access_debug_records')">
				<a class="glyphicon glyphicon-list-alt" (click)="setTab('','plink-events')"><span style="font-family:sans-serif;">&nbsp;PolarLink Events</span></a>
			</li>
			<li *ngIf="!currentUser.isEndClient" [ngClass]="{active: activePage == 'rt-records'}">
				<a class="glyphicon glyphicon-time" (click)="setTab('','rt-records')"><span style="font-family:sans-serif;">&nbsp;RT Records</span></a>
			</li>
			<li *ngIf="!currentUser.isEndClient" [ngClass]="{active: activePage == 'debug-records'}">
				<a class="glyphicon glyphicon-compressed" (click)="setTab('','debug-records')"><span style="font-family:sans-serif;">&nbsp;Debug Records</span></a>
			</li>
			<li [ngClass]="{active: activePage == 'notes'}">
				<a class="glyphicon glyphicon-pencil" (click)="setTab('','notes')"><span style="font-family:sans-serif;">&nbsp;Notes</span></a>
			</li>
			<!-- Hidden legacy item as requested
			<li [ngClass]="{active: activePage == 'debug-records'}" *ngIf="userService.hasAccessFunction('access_debug_records')">
				<a class="glyphicon glyphicon-list-alt" (click)="setTab('','debug-records')"><span style="font-family:sans-serif;">&nbsp;Debug Records</span></a>
			</li>
			-->
			<!-- Hidden legacy items as requested
			<li [ngClass]="{active: activePage == 'config-track'}" *ngIf="userService.hasAccessFunction('access_device_config_track')">
				<a class="glyphicon glyphicon-list-alt" (click)="setTab('','config-track')"><span style="font-family:sans-serif;">&nbsp;Config Track</span></a>
			</li>
			<li [ngClass]="{active: activePage == 'connectivity-track'}" *ngIf="userService.hasAccessFunction('act_admin_device_management')">
				<a class="glyphicon glyphicon-transfer" (click)="setTab('','connectivity-track')"><span style="font-family:sans-serif;">&nbsp;Connectivity Track</span></a>
			</li>
			-->
		</ul>
	</div>
</div>
